/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-cycle
import {
  get as getAxios,
  put as putAxios,
  patch as patchAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });

const put = (url, { accessToken, data, params, headers }) =>
  putAxios(url, { accessToken, data, endPoint, params, headers });
const patch = (url, { accessToken, data, params, headers }) =>
  patchAxios(url, { accessToken, data, endPoint, params, headers });

export default class ForceLogout {
  static getLoginHistory({ pageNumber = 0, size = 10 }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/login-history?page=${pageNumber}&size=${size}`, {
      accessToken: accessTokenFromLocal,
    });

    ForceLogout.getLoginHistory.cancel = request.cancel;
    return request;
  }

  static activateBulk(ids = []) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/login-history/activate`, {
      accessToken: accessTokenFromLocal,
      data: ids,
      headers: { "Content-Type": "application/json" },
    });

    ForceLogout.activateBulk.cancel = request.cancel;
    return request;
  }

  static userLogout(id) {
    const accessTokenFromLocal = localStorage.getItem("authToken");

    return patch(`/api/login-history/${id}/logout`, {
      accessToken: accessTokenFromLocal,
      headers: { "Content-Type": "application/json" },
    });
  }
}
